import { k } from "../core/kaplay";
import { saveSettings, settings, type DesktopControls, type TouchControls } from "../core/settings";
import { addButton, addTitle, addUiRoot } from "../ui/layout";

const DESKTOP_LABELS: Record<DesktopControls, string> = {
    keyboard: "Keyboard",
    mouse: "Mouse",
};

const TOUCH_LABELS: Record<TouchControls, string> = {
    dpad: "D-pad + buttons",
    freeride: "One-thumb",
};

function nextOf<T extends string>(labels: Record<T, string>, current: T): T {
    const options = Object.keys(labels) as T[];
    return options[(options.indexOf(current) + 1) % options.length];
}

function change(update: () => void) {
    update();
    saveSettings();
    k.go("settings");
}

export function settingsScene() {
    const ui = addUiRoot();
    addTitle(ui, "Settings", -340, 96);

    addTitle(ui, "Desktop controls", -215, 36);
    addButton(ui, DESKTOP_LABELS[settings.desktopControls], -130, () =>
        change(() => (settings.desktopControls = nextOf(DESKTOP_LABELS, settings.desktopControls))),
    );

    addTitle(ui, "Touch screen controls", -25, 36);
    addButton(ui, TOUCH_LABELS[settings.touchControls], 60, () =>
        change(() => (settings.touchControls = nextOf(TOUCH_LABELS, settings.touchControls))),
    );
    if (settings.touchControls === "freeride") addTitle(ui, "One-thumb is coming soon - using D-pad for now", 130, 24);

    addButton(ui, "Back", 300, () => k.go("menu"));
    k.onKeyPress("escape", () => k.go("menu"));
}
